export enum TypePersonEnums{
    juridica = 1,
    natural = 2
}